import {
  RemediationAssignmentSettingsTypeDto,
  RemediationAssignmentWithSourcesDto,
} from '../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import {
  Product,
  PRODUCT_CONFIG_MAP,
  ProductConfig,
} from '../constants/product.constants';

// Returns null until the assignment has loaded.
export const getProduct = (remediationAssignmentWithSources: RemediationAssignmentWithSourcesDto): Product => {
  const settings = remediationAssignmentWithSources?.remediationAssignment?.settings;
  if (!settings) {
    return null;
  }

  if (settings.type === RemediationAssignmentSettingsTypeDto.SPARK_EXAM_SETTINGS_V1) {
    return Product.SPARK;
  }

  return Product.HESI;
};

// Falls back to the default (HESI) config until the assignment has loaded.
export const getProductConfig = (product: Product): ProductConfig => {
  return PRODUCT_CONFIG_MAP[product] || PRODUCT_CONFIG_MAP[Product.HESI];
};
